import { useMutation, useQueryClient } from '@tanstack/react-query';
import { CustomerDto, updateCustomer } from '../customerAPI';

export function useUpdateCustomer() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: Partial<CustomerDto> }) => 
      updateCustomer(id, data),
    onSuccess: (_, variables) => {
      // Invalidate the customer query to refetch the updated data
      queryClient.invalidateQueries({ queryKey: ['customer', variables.id] });
    },
  });
}
